import { useQuery } from '@tanstack/react-query'
import { api } from '../utils/api'

import type { Link } from '../types'

const fetchLink = async (id?: string) => {
  const resp = await api.get(`/links/${id}`)
  return resp.data.data ?? []
}

export const useLinkById = (id?: string) => {
  return useQuery<Link>({
    enabled: !!id,
    queryKey: ['link', id],
    queryFn: () => fetchLink(id),
  })
}
